import { createContext } from "react";

const siteContext = createContext();

export default siteContext;
